// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import TC from "@rolemodel/turbo-confirm"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

let lastFocusedElement = null
let modalElement = null

// Initialize Bootstrap modals
document.addEventListener('turbo:load', () => {
  modalElement = document.getElementById('confirm_modal')
  if (modalElement) {
    // Remove aria-hidden from modal element
    modalElement.removeAttribute('aria-hidden')

    window.confirmModal = new bootstrap.Modal(modalElement, {
      focus: false, // We'll handle focus manually
      keyboard: true
    })

    // Store the last focused element before opening modal
    modalElement.addEventListener('show.bs.modal', () => {
      lastFocusedElement = document.activeElement
      // Ensure modal is properly visible to screen readers
      modalElement.removeAttribute('aria-hidden')
      // Set focus to modal container
      modalElement.focus()
    })

    // Handle modal state changes
    modalElement.addEventListener('shown.bs.modal', () => {
      // Focus the confirm button when modal is fully shown
      const confirmButton = modalElement.querySelector('[data-confirm-button]')
      if (confirmButton) {
        confirmButton.focus()
      }
    })

    // Restore focus when modal is hidden
    modalElement.addEventListener('hide.bs.modal', () => {
      // Set aria-hidden before hiding
      modalElement.setAttribute('aria-hidden', 'true')
    })

    modalElement.addEventListener('hidden.bs.modal', () => {
      if (lastFocusedElement) {
        lastFocusedElement.focus()
      }
    })

    // Handle focus trap within modal
    modalElement.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        const focusableElements = modalElement.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
        const firstFocusableElement = focusableElements[0]
        const lastFocusableElement = focusableElements[focusableElements.length - 1]

        if (event.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus()
            event.preventDefault()
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus()
            event.preventDefault()
          }
        }
      }
    })
  }
})

TC.start({
  dialogSelector: '#confirm_modal',
  activeClass: 'show',
  acceptSelector: '[data-confirm-button]',
  denySelector: '.btn-secondary',
  animationDuration: 300,
  showConfirmCallback: (element) => {
    // Ensure modal is properly visible to screen readers before showing
    if (modalElement) {
      modalElement.removeAttribute('aria-hidden')
    }
    window.confirmModal.show()
  },
  hideConfirmCallback: (element) => {
    window.confirmModal.hide()
  },
  messageSlotSelector: '[data-confirm-title]',
  contentSlots: {
    body: {
      contentAttribute: 'confirm-details',
      slotSelector: '[data-confirm-text]'
    },
    acceptText: {
      contentAttribute: 'confirm-button',
      slotSelector: '[data-confirm-button]'
    }
  }
})
